import React from 'react'
import { ReactComponent as Logo } from '../svg/logo.svg'

// TODO: improve code reusability with PageHero.
const HomepageHero = () =>
  <div
    css={{
      minHeight: '60vh',
      position: 'relative',
    }}
  >
    <div
      css={{
        left: '50%',
        position: 'absolute',
        textAlign: 'center',
        top: '50%',
        transform: 'translate(-50%, -50%)',
        width: '100%',
      }}
    >
      <Logo width={'100'} height={'100'} />
      <h1
        css={{
          fontSize: '1.4rem',
          letterSpacing: 1,
          margin: '10px 30px 60px',
          textTransform: 'uppercase',

          '@media (min-width: 480px)': {
            fontSize: '1.6rem',
          }
        }}
      >
        Patrícia Marques
        <small
          css={{
            color: '#ea4f62',
            display: 'block',
            fontFamily: 'Lemon Tuesday',
            fontSize: '.9em',
            letterSpacing: .5,
            marginTop: 5,
            textTransform: 'none'
          }}
        >
          makeup artist
        </small>
      </h1>
    </div>
  </div>

export default HomepageHero



// WEBPACK FOOTER //
// ./src/components/HomepageHero.js